/* eslint-disable complexity */
import { QueryParams } from '../../models/states/query-params-state.interfaces';
import { isAirportCodeValid, isAlphaNumeric } from '../utils/utils.adapter';

export const validateDeepLinkParams = (queryParams: QueryParams) => {
  return {
    paxCount: queryParams.paxCount,
    originCity: validateDeepLinkAirport(queryParams.originCity),
    destinationCity: validateDeepLinkAirport(queryParams.destinationCity),
    tripType: queryParams.tripType,
    flexAirport: queryParams.flexAirport,
    cabinFareClass: queryParams.cabinFareClass,
    departureDate: queryParams.departureDate,
    awardTravel: queryParams.awardTravel,
    returnDate: queryParams.returnDate,
    meetingEventCode: validateDeepLinkMeetingEventCode(
      queryParams.meetingEventCode
    )
  };
};

const validateDeepLinkAirport = (airport?: string) => {
  return isAirportCodeValid(airport || '') && airport?.length === 3
    ? airport
    : '';
};

const validateDeepLinkMeetingEventCode = (meetingEventCode?: string) => {
  if (
    meetingEventCode &&
    meetingEventCode.length <= 5 &&
    isAlphaNumeric(meetingEventCode)
  ) {
    return meetingEventCode;
  }

  return '';
};
